import { motion } from 'framer-motion';
import { Card, CardContent } from '@/components/ui/card';
import { Video, Play, Mic, Star, Building2, Scale, Users } from 'lucide-react';
import { SPEAKER_CONFIG } from '@/lib/constants';

// Icon mapping for speaker types
const SPEAKER_ICONS = {
  Mic, Star, Building2, Scale, Users
};

/**
 * Video card component for landing page video grid
 */
export function VideoCard({ video, index, onClick }) {
  const speakerConfig = SPEAKER_CONFIG[video.speaker_type] || SPEAKER_CONFIG.influencer;
  const SpeakerIcon = SPEAKER_ICONS[speakerConfig.icon] || Mic;

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ delay: index * 0.1, duration: 0.4 }}
      viewport={{ once: true }}
      onClick={() => onClick(video)}
      className="cursor-pointer group"
      data-testid={`video-card-${index}`}
    >
      <Card className="overflow-hidden hover:shadow-lg transition-all h-full">
        <div className="relative aspect-video bg-muted">
          {video.thumbnail_url ? (
            <img src={video.thumbnail_url} alt={video.title} className="w-full h-full object-cover" />
          ) : (
            <div className="w-full h-full bg-gradient-to-br from-primary/20 to-primary/5 flex items-center justify-center">
              <Video className="h-12 w-12 text-primary/50" />
            </div>
          )}
          <div className="absolute inset-0 bg-black/30 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity">
            <div className="w-14 h-14 rounded-full bg-white/90 flex items-center justify-center">
              <Play className="h-7 w-7 text-primary fill-primary ml-1" />
            </div>
          </div>
          {video.duration_minutes && (
            <div className="absolute bottom-2 right-2 bg-black/70 text-white text-xs px-2 py-1 rounded">
              {video.duration_minutes} min
            </div>
          )}
        </div>
        <CardContent className="p-3">
          <h4 className="font-medium text-sm line-clamp-2 group-hover:text-primary transition-colors mb-2">{video.title}</h4>
          <div className="flex items-center gap-2">
            <div className={`w-6 h-6 rounded-full ${speakerConfig.color} flex items-center justify-center`}>
              <SpeakerIcon className="h-3 w-3 text-white" />
            </div>
            <span className="text-xs text-muted-foreground truncate">{video.speaker_name}</span>
          </div>
        </CardContent>
      </Card>
    </motion.div>
  );
}
